import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { MsalAuthenticationResult, MsalAuthenticationTemplate } from '@azure/msal-react';
import { getLoginRequest } from '@monorepo/shared/src/config/educatorApp/auth';
import useLoginTelemetry from './useLoginTelemetry';
import useSetAuthContextForApi from './useSetAuthContextForApi';

const USER_CANCELLED_AUTH_CODE = 'AADB2C90091';

const ErrorRedirect: React.FC<MsalAuthenticationResult> = ({ error }) => {
  if (!error || error.errorMessage?.includes(USER_CANCELLED_AUTH_CODE)) {
    window.location.replace('/');
    return null;
  }

  return <div>An error occurred: {error?.errorMessage}</div>;
};

const AuthWrapper: React.FC<{
  useAuth?: boolean;
  instance: PublicClientApplication;
}> = ({ useAuth, instance, children }): any => {
  useSetAuthContextForApi(useAuth);
  useLoginTelemetry(useAuth, instance);

  return useAuth ? (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={getLoginRequest()}
      errorComponent={ErrorRedirect}
    >
      {children}
    </MsalAuthenticationTemplate>
  ) : (
    children
  );
};

export default AuthWrapper;
